import { debounce, Grid, makeStyles } from '@material-ui/core';
import React, { useState, useCallback, useEffect } from 'react';
import CustomCard from '../../shared/CustomCard';
import CustomSearchField from '../../shared/CustomSearchField';

const useStyle = makeStyles({
  container: {
    height: '64vh',
    background: '#F2F4F7',
  },
  inputField: {
    width: '475px',
    padding: '15px 10px',
    borderRadius: '5px',
    border: '1px solid #E4E7EC',
    outline: 'none',
    marginTop: '5px',
    background: '#FEFEFE',
  },
  wrapper: {
    width: '98%',
    height: '55vh',
    margin: '10px 0px 0px 10px',
    overflowY: 'auto',
    display: 'flex',
    flexWrap: 'nowrap',
    gap: '10px',
  },
  searchBox: {
    height: '42px',
    width: '495px',
    borderRadius: '5px',
    border: '1px solid #E4E7EC',
    outline: 'none',
    margin: '16px 0px 16px 10px',
    background: '#FEFEFE',
  },
});

export function CollectionList({ selected, handleData, collections }) {
  const classes = useStyle();
  const [filteredCollectionList, setFilteredCollectionList] = useState([]);

  const handleSearch = useCallback(
    ({ target }) => {
      const query = target.value;
      const filtered = collections.filter((card) => card.title.toLowerCase().includes(query.toLowerCase()));
      const sortedArray = filtered.sort((a, b) => b.isCollectionSelected - a.isCollectionSelected);
      setFilteredCollectionList(sortedArray);
    },
    [collections],
  );

  useEffect(() => {
    const sortedArray = collections.sort((a, b) => b.isCollectionSelected - a.isCollectionSelected);
    setFilteredCollectionList(sortedArray);
  }, [collections]);

  return (
    <Grid container direction="column">
      <Grid item className={classes.searchBox}>
        <CustomSearchField handleSearch={debounce(handleSearch, 300)} placeholder="Search Collection" />
      </Grid>

      <Grid container direction="column" justifyContent="flex-start" className={classes.wrapper}>
        {filteredCollectionList?.map((card) => (
          <Grid item key={card.id}>
            <CustomCard
              name="collections"
              height="70px"
              id={card.id}
              checkbox
              thumbnail={card.thumbnail}
              title={card.title}
              subTitle={`Collection ID : ${card.id}`}
              handleChange={handleData}
              selected={selected?.includes(card?.id)}
            />
          </Grid>
        ))}
      </Grid>
    </Grid>
  );
}
